module.exports = __webpack_public_path__ + "static/img/2.4bd3637.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/5/6/1/sp/2.png
// module id = LsEV
// module chunks = 0